import HomeWeb from '../../../../presentation/pages/home'
import HomeMobile from '../../../../presentation/pages/tab'
import { useGame } from '../../../../presentation/contexts'

const MakeHome = () => {
  const { isTogether } = useGame()

  if (isTogether() === null) {
    window.location.href = '/login'
  }

  if (isTogether()) {
    return <HomeMobile />
  }

  return <HomeWeb />
}

export default MakeHome
